export enum BrowserType {
  Firefox = 'firefox',
  Safari = 'safari',
  Chrome = 'chrome',
}

export const isFirefox = () => {
  const { userAgent } = window.navigator
  return userAgent.toLowerCase().includes(BrowserType.Firefox)
}

export const isSafari = () => {
  const { userAgent } = window.navigator
  return userAgent.toLowerCase().includes(BrowserType.Safari) && !userAgent.toLowerCase().includes(BrowserType.Chrome)
}

export const isMobileDevice = () => {
  return ['iPhone', 'iPad', 'Android'].indexOf(navigator.platform) > -1 || navigator.userAgent.indexOf('Android') > -1
}

export const getClientInfo = () => {
  if (typeof window === 'undefined') return {}

  const ua = window.navigator.userAgent
  const uaData = (window.navigator as any).userAgentData

  // Modern Chromium browsers support userAgentData
  let browser = 'Unknown'
  let platform = 'Unknown'
  let deviceType = 'Desktop'

  if (uaData) {
    // Browser detection from brands
    const brands: { brand: string; version: string }[] = uaData.brands || []
    const brandNames = brands.map((b) => b.brand)

    if (brandNames.includes('Google Chrome')) browser = 'Chrome'
    else if (brandNames.includes('Microsoft Edge')) browser = 'Edge'
    else if (brandNames.includes('Opera')) browser = 'Opera'
    else if (brandNames.includes('Chromium')) browser = 'Chromium'

    platform = uaData.platform || 'Unknown'
    deviceType = uaData.mobile ? 'Mobile' : 'Desktop'
  } else {
    // Fallback for Safari/Firefox
    if (ua.includes('Firefox/')) browser = 'Firefox'
    else if (ua.includes('Edg/')) browser = 'Edge'
    else if (ua.includes('OPR/') || ua.includes('Opera')) browser = 'Opera'
    else if (ua.includes('Chrome/')) browser = 'Chrome'
    else if (ua.includes('Safari/')) browser = 'Safari'

    // Fallback device detection
    if (/Mobi|Android/i.test(ua)) deviceType = 'Mobile'
    if (/Tablet|iPad/i.test(ua)) deviceType = 'Tablet'

    // platform fallback for older browsers (not reliable)
    platform = window.navigator.platform || 'Unknown'
  }

  return {
    browser,
    platform,
    deviceType,
    userAgent: ua, // always include for debugging
  }
}
